export default {"src":"/_next/static/media/text-instruction-two.14b4e3b4.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};